import { render, staticRenderFns } from "./CompImageSlider.vue?vue&type=template&id=6b1969e6&scoped=true"
import script from "./CompImageSlider.vue?vue&type=script&lang=js"
export * from "./CompImageSlider.vue?vue&type=script&lang=js"
import style0 from "./CompImageSlider.vue?vue&type=style&index=0&id=6b1969e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1969e6",
  null
  
)

export default component.exports